var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ]
    },
    [
      _c("table", { attrs: { border: "1" } }, [
        _c("tr", [
          _c("th", [_vm._v("快递单号(提)")]),
          _vm._v(" "),
          _c("td", [
            _vm.newData.in
              ? _c(
                  "div",
                  _vm._l(_vm.newData.in, function(item) {
                    return _c("div", { key: item.sub_order }, [
                      _c("span", [_vm._v(_vm._s(item.courier_name))]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(item.sub_order))])
                    ])
                  }),
                  0
                )
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [_vm._v("快递单号(送)")]),
          _vm._v(" "),
          _c("td", [
            _vm.newData.out
              ? _c(
                  "div",
                  _vm._l(_vm.newData.out, function(item) {
                    return _c("div", { key: item.sub_order }, [
                      _c("span", [_vm._v(_vm._s(item.courier_name))]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(item.sub_order))])
                    ])
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.row.courier_mobile
              ? _c("div", [
                  _vm._v("物流联系电话:"),
                  _c("span", [_vm._v(_vm._s(_vm.row.courier_mobile))])
                ])
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      !_vm.isFactory
        ? _c("div", [
            _c("div", { staticClass: "title" }, [
              _vm._v("\n      箱码(送)\n    ")
            ]),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { data: _vm.newData.out, "empty-text": "无数据" }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "序号", type: "index", width: "50" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "box_number", label: "箱码" }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c2de137", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c2de137","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/aftersale/waybillDetial.vue
// module id = null
// module chunks = 